import { render } from "./App.vue?vue&type=template&id=1232f9ab&ts=true"
import script from "./App.ts?vue&type=script&lang=ts&external"
export * from "./App.ts?vue&type=script&lang=ts&external"

import "./App.vue?vue&type=style&index=0&id=1232f9ab&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__